<cmv-modal-base [isModalOpen]="isModalOpen" positionContent="bottom">
	<section class="validar-pld-modal">
		<button
			class="validar-pld-modal__close-btn"
			cmvBtn="icon"
			(click)="onDismissModal()">
			<i class="bi bi-x"></i>
		</button>

		<i class="bi bi-exclamation-triangle validar-pld-modal__icon"></i>

		<h1>
			<span>ATENCIÓN:</span><br />
			NO PUDIMOS CONTINUAR CON TU SOLICITUD
		</h1>

		<p>
			Por el momento no es posible continuar debido a una validación interna.<br />
			Te recomendamos acudir a tu sucursal para recibir orientación.
		</p>

		<section class="validar-pld-modal__actions">
			<button type="button" cmvBtn="action" (click)="onDismissModal()">
				Aceptar
			</button>
		</section>
	</section>
</cmv-modal-base>
